import {
  OpenFeature,
  OpenFeatureProvider,
  TypedInMemoryProvider,
  useBooleanFlagValue,
} from '@openfeature/react-sdk';
import type { ReactNode } from 'react';
import type { FlagValues } from './flag-values.ts';
import { FLAG_NAMES, FLAGS, type FlagName } from './registry.ts';

type Variant = 'on' | 'off';

type InMemoryFlag = {
  readonly variants: Readonly<Record<Variant, boolean>>;
  readonly defaultVariant: Variant;
  readonly disabled: boolean;
};

const inMemoryFlagOf = (enabled: boolean): InMemoryFlag => ({
  variants: { on: true, off: false },
  defaultVariant: enabled ? 'on' : 'off',
  disabled: false,
});

const inMemoryFlagsOf = (values: FlagValues): Record<FlagName, InMemoryFlag> =>
  Object.fromEntries(FLAG_NAMES.map((name) => [name, inMemoryFlagOf(values[name])])) as Record<
    FlagName,
    InMemoryFlag
  >;

export const startFlags = (values: FlagValues): Promise<void> =>
  OpenFeature.setProviderAndWait(new TypedInMemoryProvider(inMemoryFlagsOf(values)));

export const FlagsProvider = ({ children }: { readonly children: ReactNode }) => (
  <OpenFeatureProvider>{children}</OpenFeatureProvider>
);

export const useFlag = (name: FlagName): boolean => useBooleanFlagValue(name, FLAGS[name].defaultValue);
